import { render, staticRenderFns } from "./ProjectsTemplate.vue?vue&type=template&id=574b8086"
import script from "./ProjectsTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTemplate.vue?vue&type=style&index=0&id=574b8086&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports